<!-- @if (isBrowser && product) { -->
  <!-- <app-banner-shopping [banners]="banners"></app-banner-shopping> -->
  <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
  <section class="product-section shop-section pt-0">
    <!-- <app-loader
      class="loader-wrapper app-loader"
      *ngIf="commonService.showLoader"
    ></app-loader> -->
    <div class="container-fluid-lg">
      <div class="row gap-4 pb-4">
        <div class="d-flex gap-3 justify-content-center">
          <div
            *ngIf="isBrowser && isAuthenticated && recentProducts?.length"
            class="col-custome-3 d-none d-md-block d-lg-block d-xl-block d-xxl-block"
          >
            <div class="left-box border-0 d-flex flex-column gap-3">
              <div
                class="d-none d-xl-block d-xxl-block p-3 bg-white rounded-4"
              >
                <app-recent-view-product></app-recent-view-product>
              </div>

              <!-- <div
                class="d-none d-xl-block d-xxl-block p-3 bg-white rounded-4"
              >
                <app-new-post></app-new-post>
              </div> -->
            </div>
          </div>
          
          <div class="col-custome-9 mobile-product-detail d-flex flex-column gap-3">
            <div
              class="d-block d-md-flex d-lg-flex d-xl-flex d-xxl-flex p-4 bg-white rounded-4 mobile-product-detail mobile-p-0"
            >
              <div
                class="col-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 position-relative product-section"
              >
                <div
                  class="right-box-contain p-0 d-flex flex-column gap-3 product-left-box"
                  style="top: 160px"
                >
                  <button
                    title="Thêm vào sản phẩm yêu thích"
                    class="wishlist-button {{
                      !inWishList ? '' : 'active'
                    }} d-flex align-items-center justify-content-center"
                    (click)="addToWishlist(product.productID)" data-cta="product.wishlist" data-cta-loc="product_detail"
                    *ngIf="isBrowser && isAuthenticated && product"
                  >
                    <i
                      class="wishlist-icon {{
                        !inWishList ? 'ri-heart-line' : 'ri-heart-fill fill'
                      }} ri-lg"
                      style="margin-top: 2px"
                    ></i>
                  </button>
                  <div
                    class="product-main-1 no-arrow px-3 d-flex flex-column gap-2"
                  >
                    <div class="product-label-group"></div>
                    <owl-carousel-o
                      [options]="productMainThumbSlider"
                      #owlCar
                      class="product-slide"
                      (dragging)="isDragging = $event.dragging"
                      (changed)="getPassedData($event)"
                    >
                      <ng-container *ngIf="isBrowser && product">
                        <ng-container
                          *ngFor="let image of product.imageUrls; index as i"
                        >
                          <ng-template carouselSlide [id]="i.toString()">
                            <div
                              (click)="!isDragging && openModal(i, productDetailImageModal)" data-cta="product.image_zoom" data-cta-loc="product_detail"
                            >
                              <div class="slider-image">
                                <img
                                  [src]="
                                    image ? image : 'assets/images/product.png'
                                  "
                                  class="img-fluid min-height"
                                  alt="{{ product.name }}"
                                  title="{{ product.name }}"
                                 loading="lazy" />
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </owl-carousel-o>

                    <div
                      *ngIf="isBrowser && product"
                      class="bottom-slider-image left-slider no-arrow slick-top"
                    >
                      <owl-carousel-o [options]="productThumbSlider" (dragging)="isDragging = $event.dragging">
                        <ng-container
                          *ngFor="let image of product.imageUrls; let i = index"
                        >
                          <ng-template carouselSlide [id]="i.toString()">
                            <div>
                              <div
                                class="slider-image"
                                [class.active]="
                                  i.toString() == activeSlide.toString()
                                "
                              >
                                <button
                                  class="more-images"
                                  *ngIf="product.imageUrls.length > 4 && i == 3"
                                  (click)="!isDragging && openModal(i, productDetailImageModal)" data-cta="product.image_zoom" data-cta-loc="product_detail"
                                >
                                  Xem thêm
                                  {{ product.imageUrls.length - 4 }} ảnh
                                </button>
                                <img
                                  [src]="
                                    image ? image : 'assets/images/product.png'
                                  "
                                  style="aspect-ratio: 1; cursor: pointer"
                                  class="img-fluid img-slider"
                                  alt="{{ product.name }}"
                                  title="{{ product.name }}"
                                  (click)="!isDragging && setSlide(i.toString(), owlCar)"
                                 loading="lazy" />
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                      </owl-carousel-o>
                    </div>
                  </div>
                  <!-- <div class="d-none d-lg-block d-xl-block d-xxl-block w-100">
                    <app-button-combo [containerStyle]="'l'" [flexDirection]="'row'"></app-button-combo>
                  </div>
                  <div class="d-lg-none d-xl-none d-xxl-none w-100 mb-3">
                    <app-button-combo [containerStyle]="'m'" [flexDirection]="'row'"></app-button-combo>
                  </div> -->

                  <!-- <div class="pe-3 mt-3 d-none d-lg-block d-xl-block d-xxl-block">
                    <app-product-tags [product]="product" [vouchers]="vouchers" [style]="{ height: '60px' }"></app-product-tags>
                  </div>

                  <div class="d-block d-lg-none d-xl-none d-xxl-none">
                    <app-product-tags [product]="product" [vouchers]="vouchers" [style]="{ width: '50%' }"></app-product-tags>
                  </div> -->
                  <div
                    class="d-flex d-none d-md-flex justify-content-between p-2"
                    *ngIf="productPolicyConfig && productPolicyConfig.length > 0" style="max-width: calc(100% - 20px)">
                    <div
                      class="d-flex align-items-center justify-content-center"
                      style="position: relative; flex: 1;"
                      *ngFor="let item of productPolicyConfig; let i = index"
                      [class.has-border]="i < productPolicyConfig.length - 1"
                      [ngStyle]="{'cursor': item.direction ? 'pointer' : 'default'}"
                      (click)="gotoPolicy(item)" data-cta="product.policy" data-cta-loc="product_detail"
                    >
                      <div class="d-flex align-items-center gap-1 flex-column p-2">
                        <img
                          *ngIf="item.iconUrl"
                          [src]="item.iconUrl"
                          [alt]="item.description"
                          [title]="item.description"
                          width="24"
                          height="24"
                         loading="lazy" />
                        <div class="text-center" style="color: #242424; font-weight: 600; white-space: pre-wrap;">{{ item.description }}</div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div *ngIf="isBrowser && isAuthenticated && product">
                      <div
                        *ngIf="product.stockStatus < 8 && product.basePrice > 0"
                        class="d-none d-md-block d-lg-block d-xl-flex d-xxl-flex align-items-center product-list-section gap-4"
                      >
                        <!-- <span class="product-info-label text-start fw-bold" style="color: #000000;"> Chọn số lượng </span> -->
                        <div
                          class="product-info-content d-flex align-items-center no-gap flex-wrap w-100"
                        >
                          <div
                            class="cart_qty qty-box product-qty mt-0 w-100"
                            style="max-width: calc(100% - 20px)"
                          >
                            <span class="input-group" *ngIf="isAuthenticated">
                              <app-counter
                                *ngIf="product.cartItem"
                                [cartItem]="product.cartItem"
                                style="width: 100%; display: block"
                                [btnClass]="'bg-grey'"
                              ></app-counter>
                            </span>
                            <span class="input-group" *ngIf="!isAuthenticated">
                              <app-counter
                                *ngIf="product.cartItem"
                                [cartItem]="product.cartItem"
                                style="width: 100%; display: block"
                                [btnClass]="'bg-grey'"
                              ></app-counter>
                            </span>
                          </div>

                          <div
                            *ngIf="
                              isAuthenticated &&
                              ((product.productOrderLimit &&
                                product.productOrderLimit
                                  .maxOrderQuantityPerOrder > 0) ||
                                (product.productOrderLimit &&
                                  product.productOrderLimit
                                    .maxOrderQuantityPerDay > 0))
                            "
                            class="d-flex"
                          >
                            <ng-container>
                              <div
                                *ngIf="
                                  product.productOrderLimit &&
                                  product.productOrderLimit
                                    .maxOrderQuantityPerOrder > 0
                                "
                                style="padding-top: 16px"
                              >
                                <h6>
                                  Tối đa
                                  {{
                                    product.productOrderLimit
                                      .maxOrderQuantityPerOrder
                                  }}
                                  SP/đơn
                                </h6>
                              </div>
                              <div
                                *ngIf="
                                  product.productOrderLimit &&
                                  product.productOrderLimit
                                    .maxOrderQuantityPerDay > 0
                                "
                                style="padding-top: 16px"
                              >
                                <h6>
                                  Tối đa
                                  {{
                                    product.productOrderLimit
                                      .maxOrderQuantityPerDay
                                  }}
                                  SP/ngày
                                </h6>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="col-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 mobile-product-detail"
              >
                <app-product-contain
                  *ngIf="product"
                  [product]="product"
                  [option]="option"
                  [owlCar]="owlCar"
                  [isAuthenticated]="isAuthenticated"
                  [vouchers]="vouchers"
                  [productSuggestions]="productSuggestions"
                  [productVouchers]="productVouchers"
                  [selectedVoucherCode]="selectedVoucherCode"
                  [productBanner]="productBanner"
                  [productPolicy]="productPolicyConfig"
                ></app-product-contain>
                <!-- <app-product-action
                  *ngIf="product"
                  [product]="product">
                </app-product-action> -->
                <!-- <app-product-delivery-information
                  *ngIf="product"
                  [product]="product"
                ></app-product-delivery-information> -->
                <!-- <app-payment-option
                  [product]="product"
                  [option]="option"
                ></app-payment-option> -->
                <!-- <app-product-social-share
                  *ngIf="product"
                  [product]="product"
                  [option]="option"
                ></app-product-social-share> -->
              </div>

              <!-- <div class="col-12 related-product-2" *ngIf="product">
                <app-product-bundle [product]="product"></app-product-bundle>
              </div> -->
            </div>

            <div *ngIf="isBrowser && product" class="col-12 p-4 bg-white rounded-4">
              <app-product-details-tabs
                [product]="product"
              ></app-product-details-tabs>
            </div>

            <!-- <div class="product-list-section mt-4" *ngIf="product && productSuggestionIds && productSuggestionIds.length">
              <app-related-products
                [product]="product"
                [title]="'Sản Phẩm Gợi Ý'"
                [searchType]="'suggestions'"
                [productIds]="productSuggestionIds"
              >
              </app-related-products>
            </div> -->

            <!-- <div class="product-list-section mt-4" *ngIf="product && product.ingredients && product.ingredients.length">
              <app-related-products
                [product]="product"
                [title]="'Sản Phẩm Cùng Hoạt Chất'"
                [searchType]="'ingredients'"
                [productIds]="productIngredientIds"
              >
              </app-related-products>
            </div> -->

            <!-- <div class="product-list-section mt-4" *ngIf="product && product.manufacturer">
              <app-related-products
                [product]="product"
                [title]="'Sản Phẩm Cùng Nhà Sản Xuất'"
                [searchType]="'manufacturers'"
              >
              </app-related-products>
            </div> -->

            <div
              *ngIf="isBrowser && isAuthenticated"
              class="d-block d-xl-none d-xxl-none"
            >
              <app-recent-view-product></app-recent-view-product>
            </div>

            <app-new-post *ngIf="isBrowser"></app-new-post>
          </div>
        </div>
        <!-- <div class="col-xxl-3 col-xl-4 col-lg-5 d-none d-lg-block">
          <app-product-details-sidebar
            [product]="product"
          ></app-product-details-sidebar>
        </div> -->
      </div>
    </div>
  </section>

  <app-product-detail-image-modal *ngIf="isBrowser && product"
    #productDetailImageModal
    [title]="product.name"
    [images]="product.imageUrls"
    [active]="activeSlide"
    (currentSlide)="setSlide($event, owlCar)"
  >
  </app-product-detail-image-modal>
<!-- } -->
